import { assertNever } from 'src/utils/assertNever'

import { WorksheetAction } from '../types'

export const worksheetActionToText = (action: WorksheetAction): string => {
  switch (action) {
    case 'create':
    case 'deCreate':
      return '新規追加'
    case 'save':
      return '一時保存'
    case 'disable':
    case 'deDisable':
      return '無効化'
    case 'enable':
    case 'deEnable':
      return '有効化'
    case 'confirm':
      return '確定'
    case 'reEdit':
    case 'deReEdit':
      return '再編集'
    case 'deMainSave':
    case 'dePartnerSave':
      return '保存'
    case 'deSend':
      return '指示確定'
    case 'deAccept':
      return '受領確定'
    case 'deWithdraw':
      return '受領取り下げ'
    default:
      return assertNever(action)
  }
}
